import { useAdvancingActivityCount } from "advancing/activity/useAdvancingActivityCount";
import { useAdvancingMessageToasts } from "advancing/messages/useAdvancingMessageToasts";
import { ActivityTab } from "advancingapprove/tabs/ActivityTab";
import { CheckAndApproveTab } from "advancingapprove/tabs/CheckAndApproveTab";
import { FilesTab } from "advancingapprove/tabs/FilesTab";
import { ParticipantsTab } from "advancingapprove/tabs/ParticipantsTab";
import { getApproveActivitySource, getApproveSidePanelQuery } from "advancingapprove/utils";
import { ButtonSecondary } from "components/Atoms/Button";
import AreYouSureModal from "components/modals/AreYouSureModal";
import { AdvancingSessionHeader } from "components/PurpleHeader/AdvancingSessionHeader";
import { ShortcutBar } from "components/ShortcutBar/ShortcutBar";
import { useTabRoute } from "pages/utils";
import React, { useState } from "react";
import { useLoaderData } from "react-router";
import { useCustomQuery } from "utilities/hookutils";
import { routes } from "utilities/routing/generatedRoutes";

const tabs = [
  { key: "checkAndApprove", label: "Check & approve", Component: CheckAndApproveTab },
  { key: "participants", label: RESX.Advancing.Participants, Component: ParticipantsTab },
  { key: "files", label: RESX.File.Files, Component: FilesTab },
  { key: "activity", label: "Activity log", Component: ActivityTab }
] as const;

export const AdvancingApproveApp = () => {
  const { advancingSession } = useLoaderData<server.viewmodel.AdvancingApproveFrontModel>();
  const activityCount = useAdvancingActivityCount(getApproveActivitySource(advancingSession.advancingSessionId), advancingSession.advancingSessionId);
  const sidePanelQuery = useCustomQuery(getApproveSidePanelQuery(advancingSession.advancingSessionId));
  const { activeTab, onTabChange, getTabHref } = useTabRoute(tabs);
  useAdvancingMessageToasts(advancingSession.advancingSessionId, "toAgent");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const deleteSession = async () => {
    const response = await window.CoreApi.AdvancingSession.Delete(advancingSession.advancingSessionId);
    if (!response.data.hasErrors) window.location.href = routes.show_Detail(advancingSession.show.showId).absolute;
    return response.data;
  };

  const counts: Partial<Record<typeof tabs[number]["key"], number>> = {
    participants: sidePanelQuery.data?.data.participants.length,
    files: sidePanelQuery.data?.data.advancingSession.filesCount,
    activity: activityCount
  };

  const hasNoParticipants = sidePanelQuery.data?.data.participants.length === 0;

  return <div className="flex-column gap-large">
    <AdvancingSessionHeader advancingSession={sidePanelQuery.data?.data.advancingSession ?? advancingSession} href={routes.show_Detail(advancingSession.show.showId).absolute} />
    <div className="flex align-center justify-space-between gap">
      <ShortcutBar
        options={tabs.map(tab => ({ label: tab.label, value: tab.key, href: getTabHref(tab.key), count: counts[tab.key], isWarning: tab.key === "participants" && hasNoParticipants }))}
        value={activeTab.key}
        onChange={onTabChange}
      />
      <ButtonSecondary label="Delete Session" onClick={() => setIsDeleteModalOpen(true)} />
    </div>
    <activeTab.Component />
    {isDeleteModalOpen && <AreYouSureModal
      title="Delete Session"
      textContent={RESX.GeneralWarnings.DeleteSure}
      yesButtonLabel={RESX.Buttons.btnDelete}
      yesButtonColor="red"
      onYes={deleteSession}
      onClose={() => setIsDeleteModalOpen(false)}
    />}
  </div>;
};
